import CodeIcon from "@mui/icons-material/Code";
import { Dialog, DialogActions, DialogContent, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { Button } from "Components/_Shared/Buttons/Button";
import { Flex } from "Components/_Shared/Core/Flex";
import { HStack } from "Components/_Shared/Core/Stack";
import { TabPanel } from "Components/_Shared/Core/TabPanel";
import { ReactComponent as CloseIcon } from "Components/_Shared/Icons/Assets/close.svg";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useState } from "react";
import { DevToolsFeatureFlags } from "./DevToolsFeatureFlags";
import { DevToolsHome } from "./DevToolsHome";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const DevTools = ({ isOpen, onClose }: Props) => {
  const { t } = useResource();
  const [activeTab, setActiveTab] = useState(0);

  const handleClose = () => {
    setActiveTab(0);
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { sx: { minHeight: 400, borderRadius: Radius.XXXL } } }}
    >
      <Flex justifyContent="space-between" alignItems="center" px={Spacing.XXL} pt={Spacing.XL} pb={Spacing.S}>
        <HStack spacing={Spacing.S} alignItems="center">
          <CodeIcon color="primary" />
          <Typography variant="h2">{t(Resources.DevTools.Title)}</Typography>
        </HStack>
        <IconButton onClick={handleClose} aria-label={t(Resources.Common.Close)}>
          <CloseIcon />
        </IconButton>
      </Flex>

      <Tabs
        value={activeTab}
        onChange={(_, value: number) => setActiveTab(value)}
        sx={{ px: Spacing.XXL, borderBottom: "1px solid", borderColor: "secondary.light" }}
      >
        <Tab label={t(Resources.DevTools.Tabs.Home)} />
        <Tab label={t(Resources.DevTools.Tabs.FeatureFlags)} />
      </Tabs>

      <DialogContent sx={{ px: Spacing.XXL, py: Spacing.XL }}>
        <TabPanel value={activeTab} index={0}>
          <DevToolsHome />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <DevToolsFeatureFlags />
        </TabPanel>
      </DialogContent>

      <DialogActions sx={{ px: Spacing.XXL, pb: Spacing.XL }}>
        <Button color="secondary" onClick={handleClose}>
          {t(Resources.Common.Close)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
